import BaseModel from '../core/BaseModel'

export default class CriteriaModel extends BaseModel {
    constructor() {
        super({ 
                name: "criteria",
                tableName: 'criteria',
                label: "Định nghĩa tiêu chí", 
                display_key: 'name', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                  data.stt = index + 1;
                },
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            code: {
                name: 'code',
                type: "TEXT",
                label: 'Kí hiệu',
                sortable: false,
                width: 6,
                filter: {type: 'input', match: 'contains'},
            },
            name: {
                name: 'name',
                type: "TEXT",
                label: 'Tên tiêu chí',
                sortable: false,
                // width: 20,
                filter: {type: 'input',match: 'contains'}
            },
            count_total: {
              name: 'count_total',
              type: "TEXT",
              label: 'SL mức độ',
              class: 'center',
              sortable: false,
              width: 8,
            },
            active : {
              name: 'active', 
              type: "Selection", 
              custom: 'SelectionText',
              label: 'Hiển thị',
              class: 'center',
              width: 6,
              options: [
                {label: "Hiển thị",value: true},
                {label: "Ẩn",value: false}
              ],
              filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
            },
            updated_name : {
              name: 'updated_name', 
              type: "TEXT", 
              label: 'Người cập nhật',
            },
            updated_at: {
              name: "updated_at",
              type: "Datetime",
              label: "Cập nhật cuối",
              filter: { type: "DateRange", match: "contains" },
            },
            created_at: {
              name: "created_at",
              type: "Datetime",
              label: "Ngày tạo",
              filter: { type: "DateRange", match: "contains" },
              display: false,
            },
            
        },)
    }

}